module.exports = __webpack_public_path__ + "img/chr_ts_90_9.c958ff05.png";